






import { Component, Prop, Vue } from "vue-property-decorator";
import { FileHelper } from '@/helper/fileHelper';
import { StringHelper } from '@/helper/stringHelper';
import { DebugHelper } from "@/helper/debugHelper";
import * as def from "@/definitions";
@Component

// 複数ファイルコンバート
export default class MultiFileConverter extends Vue {
    // ファイルタイプ
    // image / document
    @Prop() private fileType!: string;

    // 入力リセットのための変数
    private uploadReady : boolean = true;

    public get accept() : string
    {
        var str = ".lcx,.lcxt";
        return str;
    }

    // ファイルオープンダイアログを開く
    public open() : void
    {
        var input = this.$refs.input as HTMLElement;
        input.click();
    }

    public sendTextSelected(text : string, name : string) : void
    {
        this.$emit("textSelected", text, name);
    }

    // イベントハンドラー
    public onFileChange(e) : void
    {
        var files : FileList = e.target.files || e.dataTransfer.files;

        if (files.length <= 0)
        {
            // ファイルの選択をキャンセルした
            return;
        }

        DebugHelper.trace("selected files number:" + files.length);

        for(var i = 0; i < files.length; ++i)
        {
            let file : File = files[i];
            let filename = file.name;

            // ファイルリーダーを作成
            let reader : FileReader = new FileReader();
            var converter = this;
            reader.onload = (function(e)
            {
                DebugHelper.trace(filename)
                converter.onLoadFile(e, filename);
            });
            reader.readAsArrayBuffer(file);
        }
        
        // 選択ファイルをクリアする
        this.reset();

        //this.$emit("importFile", reader.result);
    }

    private onLoadFile(e, orgFilename) : void
    {
        try
        {
            let result = e.target.result;

            let arrayBuffer : ArrayBuffer = result as ArrayBuffer;
            let buffer = new Uint8Array(arrayBuffer);

            // zip解凍
            let Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
            let uz = new Unzip(buffer);
            let filenames = uz.getFilenames();
            if(filenames && filenames.length > 0)
            {
                // 最初のファイル(xml)
                let filename = filenames[0];

                // 拡張子を取り除く
                let name = FileHelper.getFilenameWithoutExtension(orgFilename);
                let text = "";
                try
                {
                    let decompressed = uz.decompress(filenames);
                    text = StringHelper.utf8ArrayToStr(decompressed);
                }
                catch(e)
                {
                    DebugHelper.trace(e);
                }
                this.sendTextSelected(text, name);
            } 
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private reset()
    {
        this.uploadReady = false;
        this.$nextTick(() =>
        {
            this.uploadReady = true;
        });
    }

}
